var module = 'main', name = 'main/config/locales/fr_CA.json', content = {
  "common": {
    "time_unit": {
      "minutes": "minutes"
    },
    "contact_method_kinds": {
      "codepager": "Pagette de code",
      "speed_dial": "Code abrégé",
      "fax": "Télécopieur",
      "home": "Maison",
      "mobile": "Mobile",
      "other": "Autre",
      "pager": "Pagette",
      "pharmacy": "Pharmacie",
      "switchboard": "Téléphoniste",
      "work": "Travail"
    },
    "gender": {
      "male": "Masculin",
      "female": "Féminin",
      "other": "Autre"
    },
    "territories": {
      "be": "Belgique",
      "fr": "France",
      "ch": "Suisse",
      "us": "États-Unis",
      "ab": "Alberta",
      "bc": "Colombie-Britannique",
      "mb": "Manitoba",
      "nb": "Nouveau-Brunswick",
      "nl": "Terre-Neuve",
      "nt": "Territoires du Nord-Ouest",
      "ns": "Nouvelle-Écosse",
      "nu": "Nunavut",
      "on": "Ontario",
      "pe": "Île-du-Prince-Édouard",
      "qc": "Québec",
      "sk": "Saskatchewan",
      "yt": "Yukon"
    },
    "phone": "Téléphone",
    "add_cell_phone": "Ajouter un numéro de cellulaire",
    "add_phone": "Ajouter un numéro de téléphone",
    "selection": "Sélection"
  },
  "display_name": {
    "doctor": "Dr",
    "you": "(vous)"
  },
  "switch_language": "English Version",
  "switch_language_short": "EN",
  "page_error": "Désolé, une erreur est survenue.<br>Veuillez retourner sur le site web de votre clinique et réessayer.",
  "date": "{{date}} à {{time}}",

  "header": {
    "logout": "Fermer votre session",
    "manage_profile": "Gérer mon profil"
  },

  "patient_selection": {
    "title": "Plusieurs patients sont associés à ce compte",
    "subtitle": "Pour qui désirez-vous prendre un rendez-vous?"
  },

  "choose_reason": {
    "title": "Choisir un type de rendez-vous",
    "next_link_text": "Voir les disponibilités"
  },

  "datepicker": {
    "placeholder": "Sélectionner la date..."
  },

  "end_message": {
    "no_appointment": "Il nous est impossible de vous donner un rendez-vous pour ce service",
    "send_appointment_request_title": "Une demande de service pour un rendez-vous en {{descriptionReason}} a été acheminée à la clinique",
    "send_appointment_request_description": "Nous allons traiter votre demande et vous contacter sous peu.",
    "choose_preferences": "Veuillez nous indiquer le moment souhaité pour un éventuel rendez-vous",
    "preferences_saved": "Vos préférences ont bien été soumises à la clinique."
  },

  "flash_update_profile": {
    "no_address": {
      "no_phone": "Aucune adresse civique ni numéro de téléphone ne sont inscrits à votre dossier.",
      "with_phone": "Votre numéro de téléphone est-il toujours le {{phoneNumber}}? De plus, aucune adresse civique n'est inscrite à votre dossier."
    },
    "with_address": {
      "no_phone": "Êtes-vous toujours domicilié au {{address}}? De plus, vous n'avez pas de numéro de téléphone à votre dossier.",
      "with_phone": "Êtes-vous toujours domicilié au {{address}}? Votre numéro de téléphone est-il toujours le {{phoneNumber}}?"
    },
    "thank_you_note": "Merci de nous aider en gardant vos informations personnelles à jour dans votre profil.",
    "edit_profile": "Modifier mes informations",
    "up_to_date": "L'information est à jour"
  },

  "preferences_page": {
    "titles": {
      "details": "Préférences",
      "types": "Sélectionner le type de rendez-vous",
      "location": "Choisir votre emplacement",
      "availabilities": "Sélectionner le moment souhaité",
      "moment": "Je souhaite un rendez-vous",
      "preferences": "J'ai une préférence pour",
      "select_hcp": "Si désiré, sélectionner le ou les spécialistes souhaités",
      "none_selected": "Si aucun spécialiste n'est sélectionné, ceux-ci seront tous considérés pour les propositions de disponibilités."
    },
    "visit_reason": {
      "title": "Raison de la visite",
      "label": "Pouvez-vous nous indiquer la raison de votre visite?",
      "legend": "Cette information est à titre indicatif seulement.",
      "placeholder": "Sélectionner",
      "specify": "Veuillez préciser.",
      "max_characters": "50 caractères max",
      "other": "Autre"
    },
    "manitoba_language_access": {
      "title": "Services linguistiques",
      "label": "Veuillez choisir une des options suivantes",
      "legend": "Demande de services d’interprète en ASL – exige un délai de préparation de sept jours"
    },
    "warning": {
      "period": "Malheureusement, il n'y a aucune disponibilité dans l'horaire de votre {{familyDoctorLabel}} pour la date demandée.",
      "offerings": "Ce type de rendez-vous n'est pas offert en ligne. Veuillez communiquer avec votre clinique au {{phone}}."
    },
    "actions": {
      "notify_me": "Gérer mes notifications"
    },
    "labels": {
      "asap": "Le plus tôt possible",
      "period": "À cette date de la période en cours",
      "morning": "Le matin",
      "afternoon": "L'après-midi",
      "evening": "Le soir",
      "whenever": "Peu importe",
      "consecutive_delay": "Sélectionnez l’écart max. entre les rendez-vous"
    }
  },

  "availability_page": {
    "navigation_warning": {
      "explanations": "En quittant à cette étape du processus de prise de rendez-vous, vous perdrez la disponibilité qui vous a été réservée.",
      "title": "Voulez-vous vraiment quitter?"
    },
    "title_your_time_slot": "Disponibilité offerte",
    "title_fallback": "Nous vous avons trouvé une alternative",
    "more_availabilities_body": "Me proposer une autre disponibilité",
    "no_more_availabilities": {
      "title": "Il n'y a pas d'autre disponibilité.",
      "body": "Confirmez ce rendez-vous ou réessayez plus tard."
    },
    "no_availability": {
      "warning": {
        "with_preferences": "Pour le moment, il n'y a aucune disponibilité offerte selon vos préférences.",
        "without_preferences": "Pour le moment, il n'y a aucune disponibilité offerte.",
        "walkin": "Malheureusement, il n'y a n'y a aucune disponibilité offerte au sans rendez-vous en ce moment.",
        "family_doctor": "Malheureusement, il n'y a aucune disponibilité offerte avec votre {{familyDoctorLabel}} en ce moment.",
        "other_service": "Malheureusement, il n'y a aucune disponibilité offerte pour {{reasonKind}} en ce moment."
      },
      "title": "Que souhaitez-vous faire?",
      "message": "Vous pouvez configurer les notifications pour être avisé lorsque votre {{familyDoctorLabel}} a de nouvelles disponibilités.",
      "manage_notifications": "Gérer mes notifications",
      "edit_preferences": "Modifier mes préférences"
    },
    "appointment_error": {
      "warning": "Une erreur est survenue pendant la confirmation. Le rendez-vous n'est malheureusement plus disponible.",
      "title": "Que souhaitez-vous faire?",
      "search_availabilities": "Rechercher une autre disponibilité",
      "edit_preferences": "Modifier mes préférences"
    },
    "time_elapsed": {
      "title": "Votre temps est écoulé.",
      "message": "Vous avez perdu la disponibilité qui vous était réservée. Voulez-vous voir d'autres disponibilités?",
      "propose_another": "Me proposer une autre disponibilité"
    },
    "to": "à",
    "at": "à",
    "time_left": "Il vous reste <strong>{{timer}} minutes</strong> pour confirmer votre choix",
    "cancel": "Annuler",
    "back_link_text": "Modifier mes préférences",
    "next_link_text": "J'accepte",
    "next_walkin_link_text": "J'accepte le sans rendez-vous",
    "long_operation_notice": "Cette opération peut prendre plusieurs secondes.",
    "in_person": "Consultation en personne",
    "virtual": "Consultation virtuelle",
    "raven_message": "<p>Des quantités limitées de rendez-vous sont disponibles en ligne pour les jeudis seulement. Vérifiez chaque semaine si de nouveaux sont disponibles ou rendez-vous au Raven Song CYMHSU au 300-2450 Ontario Street, Vancouver, les jeudis de 9h à 15h30 sur la base du premier arrivé, premier servi. Si vous avez besoin d'aide, veuillez appeler le 604-331-8908.</p><p>Pour d'autres options de sans rendez-vous, consultez le site <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong></p>",
    "three_bridges_message": "<p>Des quantités limitées de rendez-vous sont disponibles en ligne pour les jeudis seulement. Vérifiez chaque semaine si de nouveaux sont disponibles ou rendez-vous au Three Bridges CYMHSU au 101-1128 Hornby St, les jeudis de 9h à 15h30 sur la base du premier arrivé, premier servi. Si vous avez besoin d'aide, veuillez appeler le 604-331-8908.</p><p>Pour d'autres options de sans rendez-vous, consultez le site <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong>.</p>",
    "northeast_message": "<p>Des quantités limitées de rendez-vous sont disponibles en ligne, les lundis et mercredis seulement. Vérifiez chaque semaine si de nouveaux sont disponibles ou passez au Northeast CYMHSU au 355-2750 E Hastings St, le lundi de 9h à 15h30 ou le mercredi de 12h à 18h, selon le principe du premier arrivé. Pour de l'aide appelez au 604-675-3896.</p><p>Pour d'autres options de sans rendez-vous, consultez le site <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong>.</p>",
    "pacific_message": "<p>Des quantités limitées de rendez-vous sont disponibles en ligne, les mardis et jeudi. Vérifiez chaque semaine si de nouveaux sont disponibles ou rendez-vous au Pacific Spirit CYMHSU au 2110 W 43rd Avenue, 3e étage, le mardi de 12h00 à 18h00 ou le jeudi de 9h00 à 15h30 sur la base du premier arrivé. Pour de l'aide, appelez au 604-267-3970.</p><p>Pour d'autres options de sans rendez-vous, visitez le site <strong><a href='https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams'>https://www.vch.ca/en/service/vancouver-child-and-youth-mental-health-and-substance-use-teams</a></strong>.</p>"
  },

  "linked_patients_page": {
    "title": "Sélectionner le ou les membres de la famille pour qui vous souhaitez prendre rendez-vous.",
    "subtitle": "Pour des services différents, sélectionner un seul membre à la fois."
  },

  "appointment": {
    "title_your_appointment": "Votre prochain rendez-vous",
    "title_your_child_appointment": "Le prochain rendez-vous de {{patientName}}",
    "patient_label": "Patient",
    "reason_label": "Type de rendez-vous",
    "professional_label": "Professionnel de la santé",
    "moment_label": "Date et heure",
    "location_label": "Lieu",
    "reminder_notice_title": "Rappel",
    "reminder_notice_text_one_reminder_one_hour": "Un rappel vous sera envoyé par <strong>{{type === 'email' ? 'courriel' : type === 'sms' ? 'message texte' : 'téléphone' }}</strong> {{ type === 'email' ? 'à' : 'au' }} <strong>{{reminders}}</strong> {{longTermTime || shortTermTime}} heure avant votre rendez-vous.",
    "reminder_notice_text_one_reminder_several_hours": "Un rappel vous sera envoyé par <strong>{{type === 'email' ? 'courriel' : type === 'sms' ? 'message texte' : 'téléphone'}}</strong> {{ type === 'email' ? 'à' : 'au' }} <strong>{{reminders}}</strong> {{longTermTime || shortTermTime}} heures avant votre rendez-vous.",
    "reminder_notice_text_one_hour": "Un rappel vous sera envoyé par <strong>{{type === 'email' ? 'courriel' : type === 'sms' ? 'message texte' : 'téléphone'}}</strong> {{ type === 'email' ? 'à' : 'au' }} <strong>{{reminders}}</strong> {{longTermTime}} heures à l'avance, puis {{shortTermTime}} heure avant le rendez-vous.",
    "reminder_notice_text_several_hours": "Un rappel vous sera envoyé par <strong>{{type === 'email' ? 'courriel' : type === 'sms' ? 'message texte' : 'téléphone'}}</strong> {{ type === 'email' ? 'à' : 'au' }} <strong>{{reminders}}</strong> {{longTermTime}} heures à l'avance, puis {{shortTermTime}} heures avant le rendez-vous.",
    "cancel_button_text": "Annuler ce rendez-vous",
    "confirmation_return_home_text": "Si vous désirez annuler ce rendez-vous, retournez à la ",
    "confirmation_return_home_link": "page d'accueil.",
    "confirmation_approx_time": "Notez bien que l’heure du rendez-vous est approximative.",
    "form": {
      "preliminary_informations": "Renseignements préalables à la prise de rendez-vous"
    },
    "virtual_appointment": "Consultation virtuelle",
    "arrived": "Présence annoncée"
  },

  "appointment_cancel": {
    "title": "Annulation de rendez-vous",
    "message": "Voulez-vous vraiment annuler votre rendez-vous",
    "infos": "avec",
    "walkin": "Voulez-vous vraiment annuler votre sans rendez-vous",
    "date": "le {{date}} à {{time}}?",
    "walkin_date": "du {{date}} à {{time}}?",
    "confirm_cancel": "Confirmer l'annulation",
    "keep_appointment": "Conserver ce rendez-vous",
    "manitoba_vaccination_title": "Êtes-vous sûr de vouloir annuler votre rendez-vous de vaccination COVID-19 ?",
    "manitoba_vaccination_message": "Deux doses sont recommandées pour la vaccination contre la COVID-19. Si vous annulez l'un des deux rendez-vous, l'autre sera automatiquement annulé."
  },

  "appointment_request_cancel": {
    "title": "Annulation de demande de service",
    "message": "Voulez-vous vraiment annuler votre demande de service ({{description}})",
    "infos": "avec",
    "date": "qui a été prise le {{date}} à {{time}}?",
    "confirm_cancel": "Confirmer l'annulation",
    "keep_appointment_request": "Conserver cette demande"
  },

  "breadcrumb": {
    "title": "Prendre un rendez-vous",
    "my_appointments": "Retourner à mes rendez-vous",
    "appointments_of": "Retourner aux rendez-vous de {{name}}",
    "steps": {
      "reasons": "Choix du service",
      "form": "Questionnaire",
      "preferences": "Préférences",
      "patients": "Patients"
    }
  },

  "footer": {
    "assistance": "Pour obtenir de l'aide pour réserver un rendez-vous, veuillez appeler le  {{phoneNumber}}",
    "terms_and_conditions": "Conditions d'utilisation",
    "privacy_policy": "Politique de confidentialité"
  },

  "date_format": {
    "long": "D MMMM HH:mm",
    "day_and_month": "Do MMMM",
    "day_month_and_year": "Do MMMM YYYY",
    "dayname_day_month_and_year": "dddd Do MMMM YYYY",
    "dayname_day_month_and_year_and_time": "dddd Do MMMM YYYY à HH:mm",
    "day_month_year_and_time": "D MMMM YYYY à HH:mm",
    "day_month_and_time": "D MMMM à HH:mm",
    "dayname_comma_day_month_year": "dddd, D MMMM YYYY",
    "only_time": "HH:mm"
  },

  "follow_up": {
    "family_doctor": "Votre {{familyDoctorLabel}}, {{professional}}, a la disponibilité suivante:",
    "walk_in": "Il y a une place disponible: {{description}}",
    "other": "Il y a aussi une disponibilité {{reasonKind}} avec {{professional}}:",
    "other_confidential": "Il y a aussi une disponibilité {{reasonKind}}"
  },

  "global": {
    "yes": "Oui",
    "no": "Non",
    "actions": "Actions"
  },

  "flash": {
    "error": {
      "title": "Oups, une erreur est survenue."
    }
  },

  "loading": {
    "generic": "Chargement...",
    "availability": "Recherche d'une disponibilité...",
    "appointment": "Confirmation du rendez-vous en cours...",
    "long_operation_notice": "Cette opération peut prendre plusieurs secondes. Merci de patienter."
  },

  "actions": {
    "btn_cancel": "Annuler",
    "btn_edit": "Modifier",
    "next": "Suivant",
    "join": "Joindre",
    "send": "Envoyer"
  },

  "attachments": {
    "select_a_file": "Sélectionner le fichier",
    "new_file": "Ajouter un fichier",
    "errors": {
      "file_too_big": "La taille du fichier excède {{size}} Mo."
    }
  },

  "dayNamesShort": {
    "sunday": "D",
    "monday": "L",
    "tuesday": "M",
    "wednesday": "M",
    "thursday": "J",
    "friday": "V",
    "saturday": "S"
  },

  "bytes":{
    "bytes": "o",
    "kilobytes": "ko",
    "megabytes": "Mo",
    "gigabytes": "Go",
    "terabytes": "To",
    "petabytes": "Po"
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/config/locales/fr_CA.json
// module id = 1329
// module chunks = 0